/**
 * Прив’язка полів модуля «ai» до понять довідника (значок «?» біля підпису поля).
 * Ключ — `ai.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary), напр. 'КЦ', 'ЦА'.
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Поле в інтерфейсі: <Field term="ai.<сутність>.<поле>">.
 */
export const AI_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Пункт контент-плану (ШІ-25): цільовий читач і комерційна цінність матеріалу.
  'ai.planItem.targetReader': 'ЦА',
  'ai.planItem.commercialValue': 'КЦ',
};
